import styled, { css } from 'styled-components'
import { hideVisually } from 'polished'

const Wrapper = styled.label`
  display: inline-flex;
  align-items: center;
`

const HiddenCheckbox = styled.input`
  ${({ theme, checked }) => css`
    ${hideVisually()};

    &:disabled + * {
      cursor: not-allowed;
      background-color: ${checked ? theme.palette.grey[500] : theme.palette.grey[200]};
      border-color: ${checked ? theme.palette.grey[500] : theme.palette.grey[200]};
    }
  `}
`

const StyledCheckbox = styled.div<{ checked: boolean }>`
  ${({ theme, checked }) => css`
    position: relative;
    flex-shrink: 0;
    display: inline-block;
    width: 3.2rem;
    height: 3.2rem;
    border: ${checked ? `0.1rem solid #234FEB` : `0.1rem solid ${theme.palette.grey[500]}`};
    background-color: ${checked ? theme.palette.grey[900] : '#ffffff'};
    transition: all 150ms;

    svg {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 2.4rem;
      height: 2.4rem;
      margin: auto;
      color: #ffffff;
    }

    ${HiddenCheckbox}:focus + & {
      outline: 0.2rem solid ${theme.palette.grey[900]};
    }

    + * {
      margin-left: ${theme.spacing(2)};
    }
  `}
`

export default {
  Wrapper,
  HiddenCheckbox,
  StyledCheckbox,
}
